import { Dialog as RadixDialog } from 'radix-ui'
import { X } from 'lucide-react'
import type { ReactNode } from 'react'
import { cn } from '../cn'

/**
 * Radix üstünde ince bir sarmalayıcı: odak tuzağı, Esc ile kapanma, kaydırma
 * kilidi ve ARIA bağlantıları oradan geliyor. Bunları elle yazmak, erişilebilir
 * bir diyaloğun en kolay kaçırılan yarısıdır.
 */
export function Dialog({
  open,
  onOpenChange,
  title,
  description,
  children,
  footer,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: ReactNode
  description?: ReactNode
  children?: ReactNode
  footer?: ReactNode
}) {
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 bg-black/40 backdrop-blur-[1px]" />
        <RadixDialog.Content
          className={cn(
            'fixed top-1/2 left-1/2 w-[min(32rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2',
            'rounded-[var(--radius-card)] border border-[var(--ad-border)] bg-[var(--ad-surface)] shadow-xl',
          )}
        >
          <div className="flex items-start justify-between gap-4 px-5 py-4">
            <div>
              <RadixDialog.Title className="text-sm font-semibold">{title}</RadixDialog.Title>
              {description && (
                <RadixDialog.Description className="mt-1 text-xs text-[var(--ad-text-muted)]">
                  {description}
                </RadixDialog.Description>
              )}
            </div>
            <RadixDialog.Close
              aria-label="Kapat"
              className="rounded p-1 text-[var(--ad-text-muted)] hover:bg-[var(--ad-surface-muted)]"
            >
              <X className="size-4" />
            </RadixDialog.Close>
          </div>
          {children && <div className="px-5 pb-4">{children}</div>}
          {footer && (
            <div className="flex justify-end gap-2 border-t border-[var(--ad-border)] px-5 py-3">
              {footer}
            </div>
          )}
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  )
}
